import {AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild} from '@angular/core';
import {TextModel} from "@white-label/components/page-builder/models/text.model";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {ModalService} from "@cybfed/ui-lib/modal/modal.service";
import {InlineEditModel} from "@white-label/components/page-builder/models/ai/inline-edit.model";
import {MediaStore} from "@cybfed/ui-lib/forms/image-input/media-gallery/media.store";
import {customSetTimeout} from "@cybfed/core/helpers/overrided-timers";
import {CardGridModel} from "@white-label/components/page-builder/models/card-grid.model";
import {HowItWorksModel} from "@white-label/components/page-builder/models/how-it-works.model";
import {NgClass} from "@angular/common";

@Component({
    selector: 'white-label-how-it-works',
    standalone: true,
    imports: [
        NgClass
    ],
    templateUrl: './how-it-works.component.html'
})
export class HowItWorksComponent {
    @Input() componentModel: HowItWorksModel =  new HowItWorksModel();
    constructor(public mainStore: MainStoreService) {
    }
}
